<template>
<b-container fluid>
  <bo-page-title />
  <section id="home">
    <HeroSection :modulePage="modulePage" v-if="isList && moduleRole('hero')" />

    <b-tabs>
      <b-tab title="Page Settings">
        <b-card v-if="moduleRole('masalah')">
          <template #header>
            <h5 class="card-title">Masalah Yang Akan Didapatkan</h5>
          </template>

          <template>
            <b-form-checkbox @change="updateShowSection($event, 'show-problem', apiGet)" id="previewProblem" value="Y" unchecked-value="N" name="preview" v-model="showContentProblem">
              Show Section?</b-form-checkbox>
          </template>

          <b-row class="mt-2">
            <b-col lg="4" v-for="(v, k) in problem" :key="`problem${k}`">
              <div class="wrap_problem">
                <div class="thumb_problem">
                  <img :src="uploader(v.image)" alt="" title="">

                  <div class="bullet-cta">
                    <b-button type="button" @click="openModal('modalMasalah', {...v, keyData: k})" variant="warning" class="btn-icon mr-0 rounded-pill" v-b-tooltip.hover title="Ubah Masalah">
                      <i class="ti-pencil"></i>
                    </b-button>
                    <b-button @click="deleteMasalah(v)" type="button" variant="danger" class="btn-icon mt-1 mr-0 rounded-pill" v-b-tooltip.hover title="Hapus Masalah">
                      <i class="ti-trash"></i>
                    </b-button>
                  </div>
                </div>

                <div class="content_problem">
                  <h3 class="font-weight-bold mb-1">{{ v.title }}</h3>
                  <p>
                    {{ v.description }}
                  </p>
                </div>
              </div>
            </b-col>

            <b-col lg="12" class="mt-3">
              <div class="text-center">
                <b-button variant="outline-primary" class="rounded-pill" @click="openModal('modalMasalah')"><i class="ti-plus"></i> Add Masalah</b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="moduleRole('solusi')">
          <template #header>
            <h5 class="card-title">Solusi</h5>
          </template>
          <div class="d-flex align-items-center">
            <template>
              <b-form-checkbox @change="updateShowSection($event, 'show-solution', apiGet)" id="previewSolution" value="Y" unchecked-value="N" name="preview" v-model="showSolution">
                Show Section?</b-form-checkbox>
            </template>

            <b-button variant="secondary" class="btn-rounded ml-auto" v-if="solusiOpen" @click="setData('solusiOpen', false)">
              Close <i class="fas fa-times ml-2"></i>
            </b-button>
            <b-button variant="outline-info" class="btn-rounded ml-auto" @click="setData('solusiOpen', true)" v-else>
              Update Content <i class="fas fa-pencil-alt ml-2"></i>
            </b-button>

          </div>
          <hr />

          <validation-observer v-slot="{ handleSubmit }" ref="VFormDescription" tag="div" v-if="solusiOpen">
            <b-form @submit.prevent="handleSubmit(doSubmitSolusi)">
              <b-card class="border mb-0">
                <template #header>
                  <h5 class="card-title">Content</h5>
                </template>
                <b-row class="mb-2">
                  <b-col md=4>
                    <div class="form-group">
                      <label class="control-label">Title <span class="text-danger">*</span></label>
                      <b-form-input v-model="solusi.asc_title" />
                      <VValidate name="Title" v-model="solusi.asc_title" rules="required|min:3|max:160" />
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md=4>
                    <div class="form-group">
                      <label class="control-label">Description</label>
                      <b-form-textarea :rows="3" v-model="solusi.asc_content" />
                      <VValidate name="Description" v-model="solusi.asc_content" rules="min:3" />
                    </div>
                  </b-col>
                </b-row>
                <template #footer>
                  <div class="text-right">
                    <b-button variant="secondary" class="btn-rounded mr-3" @click="setData('solusiOpen', false)">Cancel</b-button>
                    <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
                  </div>
                </template>
              </b-card>
            </b-form>
          </validation-observer>
          <div class="row justify-content-center" v-else>
            <div class="col-md-8 text-center">
              <h3>{{solusi.asc_title}}</h3>
              <div class="sect-heading__line"></div>
              <p>{{solusi.asc_content}}</p>
            </div>
          </div>
        </b-card>

        <b-card v-if="moduleRole('keunggulan')">
          <template #header>
            <h5 class="card-title">Keunggulan Layanan</h5>
          </template>

          <template>
            <b-form-checkbox @change="updateShowSection($event, 'show-keunggulan-layanan', apiGet)" id="previewKeunggulan" value="Y" unchecked-value="N" name="preview" v-model="showContentKeunggulanLayanan">
              Show Section?</b-form-checkbox>
          </template>

          <b-row>
            <b-col lg="4" v-for="(v, k) in keunggulan" :key="`keunggulan${k}`">
              <div class="why_choose_us_wrap h-100">
                <div class="ic_wrap position-relative text-center">
                  <img :src="uploader(v.image)" alt="" title="">

                  <div class="bullet-cta">
                    <b-button type="button" @click="openModal('modalKeunggulan', {...v, keyData: k})" variant="warning" class="btn-icon mr-0 rounded-pill" v-b-tooltip.hover title="Ubah Keunggulan">
                      <i class="ti-pencil"></i>
                    </b-button>
                    <b-button @click="deleteKeunggulan(v)" type="button" variant="danger" class="btn-icon mt-1 mr-0 rounded-pill" v-b-tooltip.hover title="Hapus Keunggulan">
                      <i class="ti-trash"></i>
                    </b-button>
                  </div>
                </div>
                <div class="desc_wrap text-center mt-2">
                  <h3 class="pb-0 font-weight-bold mt-2">{{ v.title }}</h3>
                </div>
              </div>
            </b-col>

            <b-col lg="12" class="mt-3">
              <div class="text-center">
                <b-button variant="outline-primary" class="rounded-pill" @click="openModal('modalKeunggulan')"><i class="ti-plus"></i> Add Keunggulan</b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="moduleRole('kateogri_suplai')">
          <template>
            <b-form-checkbox @change="updateShowSection($event, 'show-supply-category', apiGet)" id="previewSupplyCategory" value="Y" unchecked-value="N" name="preview" v-model="showContentSupplyCategory" class="mb-2">
              Show Section?</b-form-checkbox>
          </template>
          <template #header>
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="card-title">Kategori Suplai</h5>

              <div class="text-right">
                <b-button variant="outline-primary" class="rounded-pill" @click="openModal('modalKategoriSuplai')"><i class="ti-plus"></i> Add Kategori Suplai</b-button>
              </div>
            </div>
          </template>

          <b-row>
            <b-col lg=12>
              <b-card class="mt-2">
                <template #header>
                  <div class="d-flex justify-content-between align-items-center">
                    <h5 class="card-title">Description</h5>

                    <div class="d-flex align-items-center">
                      <b-button variant="secondary" class="btn-rounded ml-auto" v-if="supplyCategoryDescOpen" @click="setData('supplyCategoryDescOpen', false)">
                        Close <i class="fas fa-times ml-2"></i>
                      </b-button>
                      <b-button variant="outline-info" class="btn-rounded ml-auto" @click="setData('supplyCategoryDescOpen', true)" v-else>
                        Update Content <i class="fas fa-pencil-alt ml-2"></i>
                      </b-button>

                    </div>
                  </div>
                </template>                
                <hr />

                <validation-observer v-slot="{ handleSubmit }" ref="VFormSupplyCategoryDescription" tag="div" v-if="supplyCategoryDescOpen">
                  <b-form @submit.prevent="handleSubmit(doSubmitSupplyCategoryDesc)">
                    <b-card class="border mb-0">
                      <template #header>
                        <h5 class="card-title">Content</h5>
                      </template>
                      <b-row class="mb-2">
                        <b-col md=4>
                          <div class="form-group">
                            <label class="control-label">Title <span class="text-danger">*</span></label>
                            <b-form-input v-model="kategori_suplai_desc.asc_title" />
                            <VValidate name="Title" v-model="kategori_suplai_desc.asc_title" rules="required|min:3|max:160" />
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col md=4>
                          <div class="form-group">
                            <label class="control-label">Description</label>
                            <b-form-textarea :rows="3" v-model="kategori_suplai_desc.asc_content" />
                            <VValidate name="Description" v-model="kategori_suplai_desc.asc_content" rules="min:3" />
                          </div>
                        </b-col>
                      </b-row>
                      <template #footer>
                        <div class="text-right">
                          <b-button variant="secondary" class="btn-rounded mr-3" @click="setData('supplyCategoryDescOpen', false)">Cancel</b-button>
                          <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
                        </div>
                      </template>
                    </b-card>
                  </b-form>
                </validation-observer>
                <div class="row justify-content-center" v-else>
                  <div class="col-md-8 text-center">
                    <h3>{{kategori_suplai_desc.asc_title}}</h3>
                    <div class="sect-heading__line"></div>
                    <p>{{kategori_suplai_desc.asc_content}}</p>
                  </div>
                </div>
              </b-card>

              <hr />
            </b-col>
            <template v-if="!supplyCategoryDescOpen">
              <b-col lg="6" v-for="(v, k) in kategori_suplai.data" :key="`ks${k}`">
                <div class="wrap_service d-flex flex-column justify-content-center">
                  <b-row>
                    <b-col lg="6">
                      <div class="thumb_service">
                        <img :src="uploader(v.asca_image)" alt="" title="" class="loaded tns-complete">
                        <div class="svg-container ">
                          <img src="https://lingkarhub.com/clients/mitra-pengadaan/ui/assets/images/card-triangle.svg" alt="" title="" class="loaded tns-complete">
                        </div>
                        <div class="svg-container-line ">
                          <img src="https://lingkarhub.com/clients/mitra-pengadaan/ui/assets/images/card-triangle-line.svg" alt="" title="" class="loaded tns-complete">
                        </div>

                        <div class="bullet-cta" style="left: 8px;">
                          <b-button type="button" @click="openModal('modalKategoriSuplai', {...v, keyData: k})" variant="warning" class="btn-icon mr-0 rounded-pill" v-b-tooltip.hover title="Ubah Kategori Suplai">
                            <i class="ti-pencil"></i>
                          </b-button>
                          <b-button @click="deleteSupplyCategory(v)" type="button" variant="danger" class="btn-icon mt-1 mr-0 rounded-pill" v-b-tooltip.hover title="Hapus Kategori Suplai">
                            <i class="ti-trash"></i>
                          </b-button>
                        </div>
                      </div>
                    </b-col>
                    <b-col lg="6">
                      <div class="post_service">
                        <h3 class="font-weight-bold">{{ v.asca_title }}</h3>
                        <span v-html="v.asca_content"></span>

                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>

              <b-col lg="12" class="mt-3" v-if="kategori_suplai.page.total_data > kategori_suplai.page.per_page">
                <div class="d-flex justify-content-end">
                  <b-pagination class="mb-0" v-model="pageNoKS" :per-page="kategori_suplai.page.per_page" :total-rows="kategori_suplai.page.total_data" />
                </div>
              </b-col>
            </template>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab title="SEO Settings" v-if="moduleRole('seo')">
        <SEOSection />
      </b-tab>
    </b-tabs>

    <b-modal id="modalMasalah" :title="(problemRow.typeLabel == 'Added' ? 'Add' : 'Update') + ' Masalah'" size="md">
      <validation-observer v-slot="{ handleSubmit }" ref="VFormMasalah">
        <b-form @submit.prevent="handleSubmit(submitMasalah)">
          <b-row>
            <b-col md=12>
              <div class="form-group">
                <label class="control-label">Image <span class="text-danger">*</span></label>
                <Uploader v-model="problemRow.image" type="blog-content" />
                <VValidate name="Image" v-model="problemRow.image" :rules="mrValidation.image" />
              </div>
            </b-col>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Title" v-model="problemRow.title">
                <VValidate name="Title" v-model="problemRow.title" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>
            </b-col>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Description <span class="text-danger">*</span></label>
                <b-form-textarea :rows="3" v-model="problemRow.description"></b-form-textarea>
                <VValidate name="Description" v-model="problemRow.description" :rules="{ required: true, min: 3 }" />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{close}">
        <div class="text-right">
          <b-button class="btn-rounded" variant="outline-secondary" @click="close">Cancel</b-button>
          <b-button type="button" @click="submitMasalah" class="btn-rounded ml-2" variant="primary">Save Changes</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modalKeunggulan" :title="(keunggulanRow.typeLabel == 'Added' ? 'Add' : 'Update') + ' Keunggulan'" size="md">
      <validation-observer v-slot="{ handleSubmit }" ref="VFormKeunggulan">
        <b-form @submit.prevent="handleSubmit(submitKeunggulan)">
          <b-row>
            <b-col md=12>
              <div class="form-group">
                <label class="control-label">Image <span class="text-danger">*</span></label>
                <Uploader v-model="keunggulanRow.image" type="icon_keunggulan" />
                <VValidate name="Image" v-model="keunggulanRow.image" :rules="mrValidation.image" />
              </div>
            </b-col>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Title" v-model="keunggulanRow.title">
                <VValidate name="Title" v-model="keunggulanRow.title" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{close}">
        <div class="text-right">
          <b-button class="btn-rounded" variant="outline-secondary" @click="close">Cancel</b-button>
          <b-button type="button" @click="submitKeunggulan" class="btn-rounded ml-2" variant="primary">Save Changes</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modalKategoriSuplai" :title="(ksRow.typeLabel == 'Added' ? 'Add' : 'Update') + ' Keunggulan'" size="lg">
      <validation-observer v-slot="{ handleSubmit }" ref="VFormKeunggulan">
        <b-form @submit.prevent="handleSubmit(submitSupplyCategory)">
          <b-row>
            <b-col md=5>
              <div class="form-group mb-2">
                <label class="control-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Title" v-model="ksRow.asca_title">
                <VValidate name="Title" v-model="ksRow.asca_title" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>

              <div class="form-group">
                <label class="control-label">Image <span class="text-danger">*</span></label>
                <Uploader v-model="ksRow.asca_image" type="supply_category" />
                <VValidate name="Image" v-model="ksRow.asca_image" :rules="mrValidation.image" />
              </div>
            </b-col>
            <b-col md=7>
              <div class="form-group mb-2">
                <label class="control-label">Content <span class="text-danger">*</span></label>
                <CKEditor :value.sync="ksRow.asca_content" />

                <VValidate name="Content" v-model="ksRow.asca_content" :rules="{ required: 1, min: 3 }" />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{close}">
        <div class="text-right">
          <b-button class="btn-rounded" variant="outline-secondary" @click="close">Cancel</b-button>
          <b-button type="button" @click="submitSupplyCategory" class="btn-rounded ml-2" variant="primary">Save Changes</b-button>
        </div>
      </template>
    </b-modal>
  </section>

</b-container>
</template>

<script>
import GlobalVue from '@/libs/Global.vue'
import Gen from '@/libs/Gen'
import SEOSection from '@/components/SEOSection'
import HeroSection from '@/components/HeroSection'
import CKEditor from "@/components/CKEditor.vue"

export default {
  name: 'BoAboutUs',
  extends: GlobalVue,
  components: {
    SEOSection,
    HeroSection,
    CKEditor
  },
  mounted() {
    this.apiGet()
  },
  data() {
    return {
      productCatOpen: false,
      row: {},
      problem: [],
      keunggulan: [],
      validation: {},
      solusi: {},
      showContentSupplyCategory: null,
      showContentKeunggulanLayanan: null,
      showContentProblem: null,
      showSolution: null,

      problemRow: {},
      keunggulanRow: {},
      ksRow: {}, // Kategori Suplai
      kategori_suplai: {
        data: [],
        page: {
          total_data: 0,
          per_page: 2,
        }
      },
      kategori_suplai_desc: {},

      solusiOpen: false,
      supplyCategoryDescOpen: false,
      pageNoKS: 1
    }
  },
  computed: {},
  methods: {
    getSupplyCategory(page = 1) {
      Gen.apiRest('/get/' + this.modulePage + '/get-kategori-suplai', {
        params: {
          page
        }
      }, 'GET').then(res => {
        console.log(res.data)
        this.$set(this, 'kategori_suplai', res.data.kategori_suplai)
      })
    },
    setData(keyData, value) {
      this.$set(this, keyData, value)
    },
    openModal(modal, data = null) {
      this.$bvModal.show(modal)

      if (modal == "modalMasalah") {
        this.$set(this, 'problemRow', {
          typeLabel: 'Added'
        })
        if (data) this.$set(this, 'problemRow', {
          ...this.problemRow,
          ...data,
          typeLabel: 'Updated'
        })
      } else if (modal == "modalKeunggulan") {
        this.$set(this, 'keunggulanRow', {
          typeLabel: 'Added'
        })
        if (data) this.$set(this, 'keunggulanRow', {
          ...this.keunggulanRow,
          ...data,
          typeLabel: 'Updated'
        })
      } else if (modal == "modalKategoriSuplai") {
        this.$set(this, 'ksRow', {
          typeLabel: 'Added'
        })
        if (data) this.$set(this, 'ksRow', {
          ...this.ksRow,
          ...data,
          typeLabel: 'Updated'
        })
      }
    },
    deleteMasalah(data) {
      this.$swal.fire({
        title: "Do You Really Want to Delete This Data",
        text: "Data that has been deleted can't recover anymore.",
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Delete Data",
        cancelButtonText: "No, Cancel",
      }).then(button => {
        if (button.isConfirmed) {
          this.swalLoading()
          let problem = this.problem.filter(dtMasalah => dtMasalah.title != data.title)

          Gen.apiRest('/do/' + this.modulePage, {
            data: {
              type: 'updateMasalah',
              ac_value: problem,
              type_label: "Deleted"
            }
          }).then(res => {
            if (res) {
              this.$swal({
                title: res.data.message,
                icon: 'success',
              }).then(() => {
                this.$bvModal.hide('modalMasalah')
                this.apiGet()
              })
            }
          }).catch(err => {
            this.$swal({
              title: err.response.data.message,
              icon: 'error'
            })
          })
        }
      })
    },
    deleteKeunggulan(data) {
      this.$swal.fire({
        title: "Do You Really Want to Delete This Data",
        text: "Data that has been deleted can't recover anymore.",
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Delete Data",
        cancelButtonText: "No, Cancel",
      }).then(button => {
        if (button.isConfirmed) {
          this.swalLoading()
          let keunggulan = this.keunggulan.filter(dtKeunggulan => dtKeunggulan.title != data.title)

          Gen.apiRest('/do/' + this.modulePage, {
            data: {
              type: 'updateKeunggulan',
              ac_value: keunggulan,
              type_label: "Deleted"
            }
          }).then(res => {
            if (res) {
              this.$swal({
                title: res.data.message,
                icon: 'success',
              }).then(() => {
                this.$bvModal.hide('modalKeunggulan')
                this.apiGet()
              })
            }
          }).catch(err => {
            this.$swal({
              title: err.response.data.message,
              icon: 'error'
            })
          })
        }
      })
    },
    deleteSupplyCategory(data) {
      this.$swal.fire({
        title: "Do You Really Want to Delete This Data",
        text: "Data that has been deleted can't recover anymore.",
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Delete Data",
        cancelButtonText: "No, Cancel",
      }).then(button => {
        if (button.isConfirmed) {
          this.swalLoading()
          Gen.apiRest('/do/' + this.modulePage, {
            data: {
              type: 'deleteSupplyCategory',
              ...data
            }
          }).then(res => {
            if (res) {
              this.$swal({
                title: res.data.message,
                icon: 'success',
              }).then(() => {
                this.apiGet()
              })
            }
          }).catch(err => {
            this.$swal({
              title: err.response.data.message,
              icon: 'error'
            })
          })
        }
      })
    },
    showProductUpdate() {
      this.productCatOpen = true
    },
    closeProductForm() {
      this.productCatOpen = false
    },
    updateShowSection(value, slug, callback) {

      Gen.apiRest('/do/' + this.modulePage, {
        data: {
          type: 'updateShowSetting',
          value,
          slug
        }
      }).then(res => {
        if (res) {
          this.$swal({
            title: res.data.message,
            icon: 'success',
          }).then(() => {
            callback()
          })
        }
      }).catch(err => {
        this.$swal({
          title: err.response.data.message,
          icon: 'error'
        })
      })
    },
    submitMasalah() {
      this.$refs.VFormMasalah.validate().then(success => {
        if (!success) return

        this.swalLoading()
        let problem

        if (!this.problem.length) {
          problem = [{
            ...this.problemRow,
            typeLabel: null
          }]
        } else {
          if (this.problemRow.typeLabel == "Updated") {
            problem = this.problem.map((dtMasalah, kMasalah) => {
              if (kMasalah == this.problemRow.keyData) return {
                ...this.problemRow,
                keyData: null
              }
              return dtMasalah
            })
          } else {
            problem = [...this.problem, {
              ...this.problemRow,
              typeLabel: null
            }]
          }
        }

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateMasalah',
            ac_value: problem,
            type_label: this.problemRow.typeLabel
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.$bvModal.hide('modalMasalah')
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },

    submitKeunggulan() {
      this.$refs.VFormKeunggulan.validate().then(success => {
        if (!success) return

        this.swalLoading()
        let keunggulan

        if (!this.keunggulan.length) {
          keunggulan = [{
            ...this.keunggulanRow,
            typeLabel: null
          }]
        } else {
          if (this.keunggulanRow.typeLabel == "Updated") {
            keunggulan = this.keunggulan.map((dtKeunggulan, kKeunggulan) => {
              if (kKeunggulan == this.keunggulanRow.keyData) return {
                ...this.keunggulanRow,
                keyData: null
              }
              return dtKeunggulan
            })
          } else {
            keunggulan = [...this.keunggulan, {
              ...this.keunggulanRow,
              typeLabel: null
            }]
          }
        }

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateKeunggulan',
            ac_value: keunggulan,
            type_label: this.keunggulanRow.typeLabel
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.$bvModal.hide('modalKeunggulan')
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },

    submitSupplyCategory() {
      this.$refs.VFormKeunggulan.validate().then(success => {
        if (!success) return

        this.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateSupplyCategory',
            ...this.ksRow,
            type_label: this.ksRow.typeLabel
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.$bvModal.hide('modalKategoriSuplai')
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },

    doSubmitSolusi() {
      this.$refs.VFormDescription.validate().then(success => {
        if (!success) return

        this.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateSolusi',
            ...this.solusi
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.apiGet()
              this.setData('solusiOpen', false)
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },

    doSubmitSupplyCategoryDesc() {
      this.$refs.VFormSupplyCategoryDescription.validate().then(success => {
        if (!success) return

        this.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateSupplyCategoryDesc',
            ...this.kategori_suplai_desc
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.apiGet()
              this.setData('supplyCategoryDescOpen', false)
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },

    doDelete(v, params = {}, callback) {

      let id = v[params.idKey]
      let obj = params.obj || this.$route.meta.objName
      this.$swal({
        title: 'Delete this ' + obj + '?' || 'Data' + '?',
        text: "You won't be able to restore this data!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

          this.swalLoading()

          Gen.apiRest("/do/" + this.modulePage, {
              data: {
                type: params.type,
                id: id
              }
            }, "POST")
            .then((resp = {}) => {
              this.$swal({
                title: resp.data.message || 'Deleted Successfully!',
                icon: 'success',
              }).then(() => {
                callback()
              })
            })
            .catch(err => {
              if (err) {
                err.statusType = err.status
                err.status = "error"
                err.title = err.response.data.title
                err.message = err.response.data.message
                err.messageError = err.message
              }
              this.doSetAlertForm(err)
            })
        }
      })
    },
    doSubmit() {
      this.$refs.VFormClient.validate().then(success => {
        if (!success) return

        this.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateDescription',
            ...this.row
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.apiGet()
              this.productCatOpen = false
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
  },
  watch: {
    $route() {
      this.apiGet()
    },
    'pageNoKS'(v) {
      if (v) this.getSupplyCategory(v)
    }
  }
}
</script>

<style scoped>
.sect-heading__line {
  display: inline-block;
  width: 180px;
  height: 12px;
  border-radius: 20px;
  position: relative;
}

.sect-heading__line::before {
  content: '';
  position: absolute;
  top: 0;
  height: 60%;
  left: 60px;
  right: 60px;
  border-radius: 10px;
  background-color: #1AAAA2;
}
</style>
